import { BookingResponseModel } from '../types/BookingModels';

export const getBookingTopicTitles = (booking: BookingResponseModel): string[] => {
  if (booking.sessionTopics && booking.sessionTopics.length > 0) {
    return booking.sessionTopics
      .map((topic) => topic?.title?.trim())
      .filter((title): title is string => Boolean(title));
  }

  return [];
};

export const getBookingTopicLabel = (booking: BookingResponseModel): string =>
  getBookingTopicTitles(booking).join(', ');